<p class="rs-tit4">
  <span class="rs-flex">
    <span *ngIf="iconClass" class="rs-padding-right1"
      ><i class="icon-lh" [class]="iconClass" aria-hidden="true"></i
    ></span>
    {{ identifier }}
  </span>
</p>
